module.exports = __webpack_public_path__ + "finance-cn.1c991af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/tables/FinanceTable/images/finance-cn.png
// module id = FY1h
// module chunks = 0